<p>{{text}}</p>

<mat-divider aria-hidden="true"></mat-divider>

<mat-dialog-actions align="end">
    <button mat-raised-button class="close-button" mat-dialog-close>
        Close
    </button>
</mat-dialog-actions>